var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrapper',[_c('cover-section',{attrs:{"version":_vm.cover}}),_c('page-footer',{class:_vm.$style.footer,attrs:{"with-xsolla":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }